export default Object.freeze({
    JW_VERSION: "8.36.2",
    JW_KEY: "5YL9uj4sKGYXhhnBzs1ATd+FHNiCPYT72rDX3AxZyxQ0aCo/",
    DEBUG: false
})
